import React, { useState, useEffect } from "react";
import "./Home.css";
import Banner from "./Banner/Banner";
import Dashboard from "./Dashboard/Dashboard";
import Overview from "./Overview/Overview";
import UserCampaign from "../Campaign/UserCampaign/UserCampaign";
import CreateFirstCampaign from "./CreateFirstCampaign/CreateFirstCampaign";
import LinkFbPage from "./LinkFbPage/LinkFbPage";
import CampainSurvey from "./CampainSurvey/CampainSurvey";
import { useSelector, useDispatch } from "react-redux";
import Category from "../Campaign/Category/Category";
import { sidebarActions } from "../../store/sidebar-slice";
import { fetchAllCampaignDetails } from "../../store/campaigns-slice";
import { fetchHomepageProfile } from "../../store/homepage-profile-slice";
import { useNavigate } from "react-router";
import { stepsActions } from "../../store/steps-slice";
import { PuffLoader } from "react-spinners"
import { Modal } from "@mui/material";
import PaymentModal from "./PaymentModal/PaymentModal";

const Home = () => {
  //console.log(selectedCategory+"testing category");
  const [isInitialized,setInitialized] = useState(false);
  const [campaignList, setCampaignList] = useState([]);
  const [currentCampaign, setCurrentCampaign] = useState("");
  const [currentCampaignDetails, setCurrentCamapignDetails] = useState("");
  const [loadSpinner, setLoadSpinner] = useState(true);
  const [paymentModal, setPaymentModal] = useState(false)

  const loginData = useSelector((state) => state.login);
  const { data: homePageProfile, loading: homePageProfileLoading } = useSelector((state) => state.homePageProfile);
  const campaignDetail = useSelector((state) => state.campaigns.data);
  const user = useSelector((state) => state.user.user);
  const isCampaignDetailsLoading = useSelector(state => state.campaigns.loading);
 
  // const selectedCategory = useSelector((state) => state.steps.selectedCategoryData);
  const dispatch = useDispatch();
  // console.log("selected category", selectedCategory);

  const navigate = useNavigate()

  // useEffect(() => {
  //   console.log(user, "SUER DATA");
  // }, [user]);

  // useEffect(() => {
  //   dispatch(fetchHomepageProfile({
  //     businessId: user?.app_business_id
  //   }))
  // }, [ user?.app_business_id])
  useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const paymentStatus = urlParams.get("payment_status") 
      if (!paymentStatus ) return setPaymentModal(false)
      if (paymentStatus) setPaymentModal(true)
  }, []);

  useEffect(() => {
    setLoadSpinner(true);
    if (user?.app_business_id) {
    dispatch(
      fetchAllCampaignDetails({
        businessId: user?.app_business_id,
        status: ["ALL"],
        request_page: ["homepage", "myads"]
      })
    );
    dispatch(fetchHomepageProfile({ businessId: user?.app_business_id }));
    if (!homePageProfile) {
      //dispatch(fetchHomepageProfile({businessId: user?.app_business_id}))
      setLoadSpinner(true);
    }
  }
  }, [user?.app_business_id]);

  useEffect(() => {
    dispatch(sidebarActions.setSidebar(true));
    dispatch(sidebarActions.setRoute("/"));
  }, []);

  // useEffect(() => {
  //   console.log(homePageProfile, "HOMEPAGE PROFILE");
  // }, [homePageProfile]);

  useEffect(() => {
    if (campaignDetail?.length) {
      campaignDetail?.map((item) => {
        if (item?.campaign_name === currentCampaign) setCurrentCamapignDetails(item);
      });
    }
  }, [currentCampaign, campaignDetail]);

  // useEffect(() => {
  //   if  (homePageProfile?.fb_link && homePageProfile.total_campaign_rewards === 0) {
  //     navigate("/create-campaign")
  //   }
  // },[homePageProfile?.total_campaign_rewards])

  if (homePageProfileLoading || isCampaignDetailsLoading) {
    return (
      <div className="puffLoadingSpinner">
        <PuffLoader size={100} color="#0F6EFF" />
      </div>
    );
  }

  return (
    <div id="home">
      {/* {!selectedCategory && <Category />} */}
      {(!campaignDetail?.length || homePageProfile?.total_campaign_rewards === 0) && (
        <>
          <CreateFirstCampaign />
        </>
      )}
      {!!campaignDetail?.length &&  homePageProfile?.total_campaign_rewards !== 0 && (
        <>
        {/* {homePageProfile?.fb_error_code && 
          <Banner />} */}
          <Modal style={{backdropFilter: "blur(10px)"}} open={paymentModal}   >
            <>
             <PaymentModal setPaymentModal={setPaymentModal} paymentModal={paymentModal} />
            </>
          </Modal>
          <Dashboard campaigns={campaignDetail} currentCampaign={currentCampaign} setCurrentCampaign={setCurrentCampaign} campaign="campaign" />
          <Overview  campaigns={campaignDetail} />
          <UserCampaign home="home" campaigns={campaignDetail} />
        </>
      )}
      {/* <CampainSurvey /> */}
    </div>
  );
};

export default Home;
